export const SIDE_NAV_PRIMARY_BLUE_THEME = {
	id: "midnight-blue",
	name: "Midnight Blue",
	backgroundColor: "#153F6F",
	foregroundColor: "#FFFFFF",
	isDefault: true,
} as const;
